import { useEffect } from "react";
import { useRouter } from "next/router";
import { withAuthUser } from "next-firebase-auth";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useAuth } from "@/components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Accordion from "react-bootstrap/Accordion";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
import { NextSeo } from "next-seo";

function CookieAndPrivacy() {
  const { t } = useTranslation(["privacy-cookie-policy"]);

  const auth = useAuth();
  const router = useRouter();

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }, [[], auth]);

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("privacy-and-cookie")}
        description={""}
        openGraph={{
          type: "website",
          title: t("privacy-and-cookie"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/privacy-and-cookie`,
        }}
      />
      <Row key="catalogPage" className="mx-0 px-3">
        <SideLinks />
        <Col className="px-0 px-lg-5" style={{ maxWidth: "80rem" }}>
          <div className="pb-5">
            <h1 className="fs-1 fw-semibold text-center text-md-start text-uppercase">{t("privacy-and-cookie", { ns: "privacy-cookie-policy" })}</h1>
            <p>{t("title.p1")}</p>
          </div>
          <h2 className="fs-6 fw-semibold pb-2">{t("title.h2")}</h2>
          <p>{t("title.p2")}</p>
          <hr />

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-1.title")}</h2>
            <p>{t("section-1.p1")}</p>
            <p>{t("section-1.p2")}</p>
            <p>{t("section-1.p3")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-2.title1")}</h2>
            <h3 className="fs-6 fw-semibold">{t("section-2.subtitle1")}</h3>
            <p>{t("section-2.p1")}</p>
            <p>{t("section-2.p2")}</p>
            <h3 className="fs-6 fw-semibold">{t("section-2.subtitle2")}</h3>
            <p>{t("section-2.p3")}</p>
            <ul>
              <li>{t("section-2.li1")}</li>
              <li>{t("section-2.li2")}</li>
              <li> {t("section-2.li3")}</li>
              <li>{t("section-2.li4")}</li>
              <li>{t("section-2.li5")}</li>
            </ul>
            <p>{t("section-2.p4")}</p>

            <h3 className="fs-6 fw-semibold">{t("section-2.subtitle3")}</h3>
            <p>{t("section-2.p5")}</p>
            <p>{t("section-2.p6")}</p>
            <p>{t("section-2.p7")}</p>
            <p>{t("section-2.p8")}</p>

            <h3 className="fs-6 fw-semibold">{t("section-2.subtitle4")}</h3>
            <p>{t("section-2.p9")}</p>
            <span>{t("section-2.p10")}</span>
            <ul>
              <li>{t("section-2.li6")}</li>
              <li>{t("section-2.li7")}</li>
            </ul>
            <p>{t("section-2.p11")}</p>
            <p>{t("section-2.p12")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold pb-2">{t("section-3.title1")}</h2>
            <p>{t("section-3.p1")}</p>
            <p>{t("section-3.p2")}</p>
            <hr />

            <h2 className="fs-6 fw-semibold pb-2">{t("section-4.title1")}</h2>
            <p>{t("section-4.p1")}</p>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <span className="fw-semibold">{t("section-4.accordion1-title1")}</span>
                </Accordion.Header>
                <Accordion.Body>
                  <p>{t("section-4.accordion1-p1")}</p>
                  <p className="fw-semibold">{t("section-4.accordion1-p2")}</p>
                  <p>{t("section-4.accordion1-p3")}</p>
                  <p>{t("section-4.accordion1-p4")}</p>
                  <p>
                    {t("section-4.accordion1-p5")}
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                      {t("section-4.accordion1-a1")}
                    </a>
                  </p>
                  <p>{t("section-4.accordion1-p6")}</p>
                  <p>{t("section-4.accordion1-p7")}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <span className="fw-semibold">{t("section-4.accordion2-title1")}</span>
                </Accordion.Header>
                <Accordion.Body>
                  <p className="fw-semibold">{t("section-4.accordion2-p1")}</p>
                  <p>{t("section-4.accordion2-p2")}</p>
                  <p>{t("section-4.accordion2-p3")}</p>
                  <p>{t("section-4.accordion2-p4")}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <span className="fw-semibold">{t("section-4.accordion3-title1")}</span>
                </Accordion.Header>
                <Accordion.Body>
                  <p>{t("section-4.accordion3-p1")}</p>
                  <p className="fw-semibold">{t("section-4.accordion3-p2")}</p>
                  <p>{t("section-4.accordion3-p3")}</p>
                  <p>{t("section-4.accordion3-p4")}</p>
                  <p>
                    {t("section-4.accordion3-p5")}{" "}
                    <a href="https://sentry.io/privacy/" target="_blank" rel="noreferrer">
                      {t("section-4.accordion3-a1")}
                    </a>
                    .
                  </p>
                  <p>{t("section-4.accordion3-p6")}</p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold">{t("section-5.title1")}</h2>
            <p>{t("section-5.p1")}</p>
            <span>{t("section-5.p2")}</span>
            <ul>
              <li>
                <span className="fw-semibold">{t("section-5.li1")}</span>
                <span>{t("section-5.li2")}</span>
              </li>
              <li>
                <span className="fw-semibold">{t("section-5.li3")}</span>
                <span>{t("section-5.li4")}</span>
              </li>
              <li>
                <span className="fw-semibold">{t("section-5.li5")}</span>
                <span>{t("section-5.li6")}</span>
              </li>
              <li>
                <span className="fw-semibold">{t("section-5.li7")}</span>
                <span>{t("section-5.li8")}</span>
              </li>
              <li>
                <span className="fw-semibold">{t("section-5.li9")}</span>
                <span>{t("section-5.li10")}</span>
              </li>
              <li>
                <span className="fw-semibold">{t("section-5.li11")}</span>
                <span>{t("section-5.li12")}</span>
              </li>
              <li>
                <span className="fw-semibold">{t("section-5.li13")}</span>
                <span>{t("section-5.li14")}</span>
              </li>
              <li>
                <span className="fw-semibold">{t("section-5.li15")}</span>
                <span>{t("section-5.li16")}</span>
              </li>
            </ul>
            <span className="fw-semibold">{t("section-5.subtitle1")}</span>
            <p>{t("section-5.p3")}</p>
            <p>{t("section-5.p4")}</p>
            <span className="fw-semibold">{t("section-5.subtitle2")}</span>
            <p>{t("section-5.p5")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold">{t("section-6.title1")}</h2>

            <span className="fw-semibold">{t("section-6.subtitle1")}</span>
            <p>{t("section-6.p1")}</p>

            <span className="fw-semibold">{t("section-6.subtitle2")}</span>
            <p>{t("section-6.p2")}</p>

            <span className="fw-semibold">{t("section-6.subtitle3")}</span>
            <p>{t("section-6.p3")}</p>

            <span className="fw-semibold">{t("section-6.subtitle4")}</span>
            <p>{t("section-6.p4")}</p>

            <span className="fw-semibold">{t("section-6.subtitle5")}</span>
            <p>{t("section-6.p5")}</p>

            <span className="fw-semibold">{t("section-6.subtitle6")}</span>
            <p>{t("section-6.p6")}</p>
            <p>{t("section-6.p7")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold">{t("section-7.title1")}</h2>
            <p>{t("section-7.p2")}</p>
            <p>{t("section-7.p2")}</p>

            <p>{t("section-7.p3")}</p>

            <span className="fw-semibold">{t("section-7.subtitle1")}</span>
            <p>
              <span>{t("section-7.p4")}</span>
              <span className="fw-semibold">{t("section-7.p5")}</span>
            </p>

            <span className="fw-semibold">{t("section-7.subtitle2")}</span>
            <p>{t("section-7.p6")}</p>
            <p>{t("section-7.p7")}</p>

            <span className="fw-semibold">{t("section-7.subtitle3")}</span>
            <p>{t("section-7.p8")}</p>
            <p>{t("section-7.p9")}</p>

            <span className="fw-semibold">{t("section-7.subtitle4")}</span>
            <p>{t("section-7.p10")}</p>
            <p>{t("section-7.p11")}</p>
            <p>{t("section-7.p12")}</p>

            <span className="fw-semibold">{t("section-7.subtitle5")}</span>
            <p>
              <span>{t("section-7.p13")}</span>
              <span className="fw-semibold"> {t("section-7.p14")}</span>
            </p>
            <p>{t("section-7.p15")}</p>
            <p className="fw-semibold">{t("section-7.subtitle6")}</p>
            <p>{t("section-7.p16")}</p>

            <span className="fw-semibold">{t("section-7.subtitle7")}</span>
            <p>{t("section-7.p17")}</p>

            <span className="fw-semibold">{t("section-7.subtitle8")}</span>
            <p>{t("section-7.p18")}</p>
            <p>{t("section-7.p19")}</p>
            <p>{t("section-7.p20")}</p>

            <p className="fw-semibold">{t("section-7.title2")}</p>
            <span className="fw-semibold">{t("section-7.subtitle9")}</span>
            <p>{t("section-7.p21")}</p>
            <ul>
              <li>{t("section-7.li1")}</li>
              <li>
                {t("section-7.li2")}
                <ul>
                  <li>{t("section-7.li3")}</li>
                  <li>{t("section-7.li4")}</li>
                </ul>
              </li>
            </ul>
            <p>{t("section-7.p22")}</p>
            <p>{t("section-7.p23")}</p>

            <span className="fw-semibold">{t("section-7.subtitle10")}</span>
            <p>{t("section-7.p24")}</p>
            <p>{t("section-7.p25")}</p>
            <p className="fw-semibold">{t("section-7.subtitle11")}</p>
            <p>{t("section-7.p26")}</p>
            <p>{t("section-7.p27")}</p>
            <ul>
              <li>{t("section-7.li5")}</li>
              <li>{t("section-7.li6")}</li>
            </ul>
            <p>{t("section-7.p28")}</p>
            <p>{t("section-7.p29")}</p>
            <p>{t("section-7.p30")}</p>
            <p>{t("section-7.p31")}</p>

            <span className="fw-semibold">{t("section-7.subtitle12")}</span>
            <p>{t("section-7.p32")}</p>
            <p>{t("section-7.p33")}</p>
            <p>{t("section-7.p34")}</p>
            <p>{t("section-7.p35")}</p>
            <p>{t("section-7.p36")}</p>
            <hr />
          </div>

          <div className="py-1">
            <h2 className="fs-6 fw-semibold">{t("section-8.title1")}</h2>
            <p>
              {t("section-7.p1")} (<span className="fw-semibold">LGPD</span>).
            </p>
            <span className="fw-semibold">{t("section-8.subtitle1")}</span>

            <p>{t("section-8.p2")}</p>

            <ul>
              <li>{t("section-8.li1")}</li>
              <li>{t("section-8.li2")}</li>
              <li>{t("section-8.li3")}</li>
              <li>{t("section-8.li4")}</li>
              <li>{t("section-8.li5")}</li>
              <li>{t("section-8.li6")}</li>
              <li>{t("section-8.li7")}</li>
              <li>{t("section-8.li8")}</li>
              <li>{t("section-8.li9")}</li>
              <li>{t("section-8.li10")}</li>
            </ul>

            <p>{t("section-8.p3")}</p>

            <span className="fw-semibold">{t("section-8.subtitle2")}</span>
            <p>{t("section-8.p4")}</p>

            <span className="fw-semibold">{t("section-8.subtitle3")}</span>
            <p>{t("section-8.p5")}</p>
            <p className="fw-semibold">{t("section-8.title2")}</p>
            <p className="fw-semibold">{t("section-8.subtitle4")}</p>
            <p>{t("section-8.p6")}</p>
            <ul>
              <li>{t("section-8.li11")}</li>
              <li>{t("section-8.li12")}</li>
              <li>{t("section-8.li13")}</li>
              <li>{t("section-8.li14")}</li>
              <li>{t("section-8.li15")}</li>
              <li>{t("section-8.li16")}</li>
              <li>{t("section-8.li17")}</li>
              <li>{t("section-8.li18")}</li>
              <li>{t("section-8.li19")}</li>
              <li>{t("section-8.l20")}</li>
              <li>{t("section-8.li21")}</li>
              <li>{t("section-8.li22")}</li>
              <li>{t("section-8.li23")}</li>
            </ul>

            <p>{t("section-8.p7")}</p>

            <span className="fw-semibold">{t("section-8.subtitle5")}</span>
            <p>{t("section-8.p8")}</p>
            <span className="fw-semibold"> {t("section-8.subtitle6")}</span>
            <p>{t("section-8.p9")}</p>

            <p>{t("section-8.p10")}</p>

            <p>{t("section-8.p11")}</p>

            <span className="fw-semibold">{t("section-8.subtitle7")}</span>
            <p>{t("section-8.p12")}</p>

            <ul>
              <li>{t("section-8.li24")}</li>
              <li>{t("section-8.li25")}</li>
              <li>{t("section-8.li26")}</li>
              <li>{t("section-8.li27")}</li>
              <li>{t("section-8.li28")}</li>
              <li>{t("section-8.li29")}</li>
            </ul>
            <hr />
          </div>
          {/* <div className="py-1">
            <h2 className="fs-6 fw-semibold">Change preferences</h2>
            <p>You can change your preferences at any time using the toggles below</p>
            <span>ADD TOGGLE HERE FOR EACH SERVICE THAT CAN BE SWITCHED ON/OFF</span>
            <hr />
          </div> */}
          <div className="py-1">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <span className="fw-semibold">{t("section-9.title1")}</span>
                </Accordion.Header>
                <Accordion.Body>
                  <span className="fw-semibold">{t("section-9.subtitle1")}</span>
                  <p>{t("section-9.p1")}</p>

                  <span className="fw-semibold">{t("section-9.subtitle2")}</span>
                  <p>{t("section-9.p2")}</p>

                  <span className="fw-semibold">{t("section-9.subtitle3")}</span>
                  <p>{t("section-9.p3")}</p>

                  <span className="fw-semibold">{t("section-9.subtitle4")}</span>
                  <p>{t("section-9.p4")}</p>

                  <span className="fw-semibold">{t("section-9.subtitle5")}</span>
                  <p>{t("section-9.p5")}</p>

                  <span className="fw-semibold">{t("section-9.subtitle6")}</span>
                  <p>{t("section-9.p6")}</p>

                  <span className="fw-semibold">{t("section-9.subtitle7")}</span>
                  <p>{t("section-9.p7")}</p>

                  <span className="fw-semibold">{t("section-9.subtitle8")}</span>
                  <p>{t("section-9.p8")}</p>
                  <span className="fw-semibold">{t("section-9.subtitle9")}</span>
                  <p>{t("section-9.p9")}</p>
                  <span className="fw-semibold">{t("section-9.subtitle10")}</span>
                  <p>{t("section-9.p10")}</p>
                  <span className="fw-semibold">{t("section-9.subtitle11")}</span>
                  <p>{t("section-9.p11")}</p>
                  <hr />
                  <span className="fw-semibold">{t("section-9.subtitle12")}</span>
                  <p>{t("section-9.p12")}</p>
                  <p>{t("section-9.p13")}</p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <hr />
          </div>
          <div className="py-1">
            <p>{t("footer.last-update")}</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "header", "footer", "privacy-cookie-policy", "services-side-links", "db-translations"])),
    },
  };
}

export default withAuthUser({})(CookieAndPrivacy);
